module.exports = __webpack_public_path__ + "media/images/logo-18cc136c.png";